/*
 * @FilePath: /eshop-ops-web/src/api/goodsManage/baseDepot.js
 * @Description: 商品基础库
 * @Author: xiexingzhong2012@sina.cn
 * @Date: 2023-07-24 19:33:23
 * @LastEditTime: 2023-07-30 09:46:32
 * @LastEditors: xiexingzhong2012@sina.cn
 */
import request from '@/utils/request'
import { Message } from 'element-ui'

//基础库 新增商品
export function addGsoodsbase(data) {
  return request({
    url: "/product/compliance/goodsbase",
    method: "post",
    data: data,
  });
}

// 根据id 查询属性
export function getAttributeByTypeId(data) {
  return request({
    url: "/product/compgoodsattribute/getAttributeByTypeId",
    method: "get",
    params: data,
  });
}


// /compliance/goodsbase/queryGoodsBasePage
// 查询基库商品列表
export function queryGoodsBasePage(data) {
  return request({
    url: "/product/compliance/goodsbase/queryGoodsBasePage",
    method: "get",
    params: data,
  });
}

// 查询商家申请列表（商家创建的商品）
export function queryShopPage(data) {
  return request({
    url: "/product/compliance/goodsbase/queryShopPage",
    method: "get",
    params: data,
  });
}

// /compliance/goodsbase/getCompGoodsBaseDetail
// 查询商品基础库详情
export function getCompGoodsBaseDetail(data) {
  return request({
    url: "/product/compliance/goodsbase/getCompGoodsBaseDetail",
    method: "get",
    params: data,
  });
}

// 修改商品详情
export function updateCompGoodsBaseDetail(data) {
  return request({
    url: "/product/compliance/goodsbase/update",
    method: "POST",
    data: data,
  });
}

// /compliance/goodsbase/auditGoodsBase 审核商品 

export function auditGoodsBase(data) {
  return request({
    url: "/product/compliance/goodsbase/auditGoodsBase",
    method: "POST",
    params: data,
  });
}

// offlineGoodsBase 全网下架

export function offlineGoodsBase(data) {
  return request({
    url: "/product/compliance/goodsbase/offlineGoodsBase",
    method: "POST",
    params: data,
  });
}


// 商品审核 列表 查询

export function goodsCheckPage(data) {
  return request({
    url: "/product/compliance/goodscheck/page",
    method: "get",
    params: data,
  });
}

// 商品审核  详情查询
export function goodsCheckDetail(data) {
  return request({
    url: `/product/compliance/goodscheck/${data.goodsId}/${data.skuId}`,
    method: "get", 
  });
}
 
//商品审核详情  更新审核结果    （审核，驳回） 
export function goodsCheckResult(data) {
  return request({
    url: "/product/compliance/goodscheck/checkResult",
    method: "post",
    data: data,
  });
}

// 商家申请
// 查询商品详情
// /compgoodstemporary/getGoodsTemporaryDetail

export function getGoodsTemporaryDetail(data) {
  return request({
    url: "/product/compgoodstemporary/getGoodsTemporaryDetail",
    method: "get",
    params: data,
  });
}

// /compgoodstemporary/reject
// 商家申请驳回
export function goodsTemporaryReject(data) {
  return request({
    url: "/product/compgoodstemporary/reject",
    method: "post",
    data: data,
  });
}

// 纠错 查询列表
export function correctionPage(data) {
  return request({
    url: "/product/compliance/correction/page",
    method: "get",
    params: data,
  });
}
 
// 基础库 查询详情信息
export function getCorrectionDetail(data) {
  return request({
    url: `/product/compliance/correction/${data.id}`,
    method: "get", 
  });
}


// /compliance/correction/check
//  商品纠错审核
export function correctionCheck(data) {
  return request({
    url: "/product/compliance/correction/check",
    method: "post",
    data: data,
  });
}
 
//发布 新增商品
export function goodstemporarySave(data) {
  return request({
    url: "/product/compgoodstemporary/save",
    method: "post",
    data: data,
  });
}


// 纠错 查询详情信息
export function getGoodsbaseDetail(data) {
  return request({
    url: `/product/compliance/goodsbase/${data.id}`,
    method: "get", 
  });
}
 
 

//发布 新增商品纠错
export function addGoodsCorrection(data) {
  return request({
    url: "/product/compliance/correction/addGoodsCorrection",
    method: "post",
    data: data,
  });
}

// /compgoodstemporary/update
// 修改商品临时表
export function compgoodstemporaryUpdate(data) {
  return request({
    url: "/product/compgoodstemporary/update",
    method: "post",
    data: data,
  });
}

// 删除基础商品
export function deleteGoods(data) {
  return request({
    url: `/product/compliance/goodsbase/delete/${data}`,
    method: "delete",
    data: {},
  });
}
//全网下架查询上架商品的个数
export function getGoodsSkuCount(data) {
  return request({
    url: `/product/compliance/sku/getGoodsSkuCount`,
    method: "get", 
    params:data
  });
}
 

